const $ = jQuery;

const t = (key, fallback = '') => (window.SPRAGA_I18N && SPRAGA_I18N[key]) || fallback || key;

$(function () {

    // Init jQuery Validation for login & registration forms
    function initAuthFormsValidation() {
        // Remove default Woo privacy text block
        $('.woocommerce-privacy-policy-text').remove();

        // If jQuery Validation plugin is not loaded – do nothing
        if (typeof $.fn.validate !== 'function') {
            return;
        }

        // LOGIN FORM
        var $loginForm = $('form.woocommerce-form-login.login');
        if ($loginForm.length && !$loginForm.data('validator')) {
            // Disable native browser validation
            $loginForm.attr('novalidate', 'novalidate');

            $loginForm.validate({
                // Use span as error element
                errorElement: 'span',
                errorClass: 'woocommerce-input-error',

                // Place error messages for inputs except checkbox/radio
                errorPlacement: function (error, element) {
                    // Skip messages for checkboxes & radios
                    if (element.is(':checkbox') || element.is(':radio')) {
                        return;
                    }

                    const $row = element.closest('.form-row');

                    if ($row.length) {
                        error.insertAfter($row);
                    } else {
                        error.insertAfter(element);
                    }
                },

                // Remove error element from DOM when field becomes valid
                success: function (label, element) {
                    const $el = $(element);

                    // Skip checkboxes/radios
                    if ($el.is(':checkbox') || $el.is(':radio')) {
                        return;
                    }

                    // Completely remove error span from DOM
                    $(label).remove();
                }
            });
        }

        // REGISTER FORM
        var $registerForm = $('form.woocommerce-form-register.register');
        if ($registerForm.length && !$registerForm.data('validator')) {
            $registerForm.attr('novalidate', 'novalidate');

            $registerForm.validate({
                errorElement: 'span',
                errorClass: 'woocommerce-input-error',

                errorPlacement: function (error, element) {
                    if (element.is(':checkbox') || element.is(':radio')) {
                        return;
                    }

                    const $row = element.closest('.form-row');

                    if ($row.length) {
                        error.insertAfter($row);
                    } else {
                        error.insertAfter(element);
                    }
                },

                // Same logic: remove error span once field is valid
                success: function (label, element) {
                    const $el = $(element);

                    if ($el.is(':checkbox') || $el.is(':radio')) {
                        return;
                    }

                    $(label).remove();
                }
            });
        }
    }

    // Init AJAX login for login form
    function initAjaxLogin() {
        var $loginForm = $('#custom-login-form').find('form.woocommerce-form-login.login');

        if (!$loginForm.length) {
            return;
        }

        // Prevent double-binding
        if ($loginForm.data('ajax-login-initialized')) {
            return;
        }
        $loginForm.data('ajax-login-initialized', true);

        // One common messages box for both login & register
        var $messages = $loginForm.closest('.woocommerce').find('.woocommerce-notices-wrapper');

        $loginForm.on('submit', function (e) {
            e.preventDefault();

            // If jQuery Validate exists and validator attached – validate first
            if (typeof $.fn.validate === 'function' && $loginForm.data('validator')) {
                if (!$loginForm.valid()) {
                    return;
                }
            }

            // Clear previous messages
            $messages
                .empty()
                .removeClass('has-error has-success');

            var data = {
                action: 'spraga_ajax_login',
                username: $loginForm.find('input[name="username"]').val(),
                password: $loginForm.find('input[name="password"]').val(),
                rememberme: $loginForm.find('input[name="rememberme"]').is(':checked') ? 1 : 0,
                security: $loginForm.find('#woocommerce-login-nonce').val(),
                redirect_to: $loginForm.find('input[name="redirect"]').val()
            };

            $loginForm.addClass('is-loading'); // optional: custom loading state

            $.post(spraga_obj.ajax_url, data)
                .done(function (response) {
                    $loginForm.removeClass('is-loading');

                    if (response && response.success) {
                        var redirectUrl = response.data && response.data.redirect
                            ? response.data.redirect
                            : window.location.href;

                        window.location.href = redirectUrl;
                    } else {
                        var message = response && response.data && response.data.message
                            ? response.data.message
                            : t("login_failed", "Login failed. Please try again.");

                        var errorHtml = '<ul class="woocommerce-error message-wrapper" role="alert"><li><div class="message-container container alert-color"><span class="message-icon icon-close"></span>' + message + '</div></li></ul>';
                        $messages.html(errorHtml).addClass('has-error');
                    }
                })
                .fail(function () {
                    $loginForm.removeClass('is-loading');

                    var html = '<ul class="woocommerce-error message-wrapper" role="alert"><li><div class="message-container container alert-color"><span class="message-icon icon-close"></span>' + t("something_went_wrong_try_again", "Something went wrong. Please try again.") + '</div></li></ul>';
                    $messages.html(html).addClass('has-error');
                });
        });
    }

    // Init AJAX register for registration form
    function initAjaxRegister() {
        var $registerForm = $('#custom-registration-form').find('form.woocommerce-form-register.register');

        if (!$registerForm.length) {
            return;
        }

        // Prevent double-binding
        if ($registerForm.data('ajax-register-initialized')) {
            return;
        }
        $registerForm.data('ajax-register-initialized', true);

        // Same messages box as for login
        var $messages = $registerForm.closest('.woocommerce').find('.woocommerce-notices-wrapper');

        $registerForm.on('submit', function (e) {
            e.preventDefault();

            // If jQuery Validate exists and validator attached – validate first
            if (typeof $.fn.validate === 'function' && $registerForm.data('validator')) {
                if (!$registerForm.valid()) {
                    return;
                }
            }

            // Clear previous messages
            $messages
                .empty()
                .removeClass('has-error has-success');

            var data = {
                action: 'spraga_ajax_register',
                email: $registerForm.find('input[name="email"]').val(),
                register_terms: $registerForm.find('input[name="register_terms"]').is(':checked') ? 1 : 0,
                security: $registerForm.find('#woocommerce-register-nonce').val(),
                redirect_to: window.location.href // or leave empty, PHP will fallback to My Account
            };

            $registerForm.addClass('is-loading');

            $.post(spraga_obj.ajax_url, data)
                .done(function (response) {
                    $registerForm.removeClass('is-loading');

                    if (response && response.success) {
                        var $container = $('#custom-registration-form');
                        
                        // Hide registration form only (keep header)
                        $container.find('form.register').hide();

                        // Remove existing success message if any
                        $container.find('.registration-success-message').remove();

                        // Add success message
                        const successHtml = `
                            <div class="registration-success-message">
                                <p>
                                    <strong>${t("welcome", "Welcome!")}</strong>
                                    <span class="success-message-subtext">
                                        ${t("account_created", "Your account has been created.<br> You’ll receive an email shortly to set your password.")}
                                    </span>
                                </p>
                                <div class="btn-box">
                                    <button type="button" class="woocommerce-Button woocommerce-button btn-form btn-reset-registration">
                                        ${t("check_your_inbox", "Check your inbox")}
                                    </button>
                                </div>
                            </div>
                        `;

                        $container.find('.account-form-body').append(successHtml);

                        // Handle reset button click
                        $(document).off('click', '.btn-reset-registration').on('click', '.btn-reset-registration', function() {
                            $container.find('.registration-success-message').remove();
                            $container.find('form.register').show();
                            $registerForm[0].reset();
                        });
                    } else {
                        var message = response && response.data && response.data.message
                            ? response.data.message
                            : t("registration_failed", "Registration failed. Please try again.");

                        var errorHtml = '<ul class="woocommerce-error message-wrapper" role="alert"><li><div class="message-container container alert-color"><span class="message-icon icon-close"></span>' + message + '</div></li></ul>';
                        $messages.html(errorHtml).addClass('has-error');
                    }
                })
                .fail(function () {
                    $registerForm.removeClass('is-loading');

                    var html = '<ul class="woocommerce-error message-wrapper" role="alert"><li><div class="message-container container alert-color"><span class="message-icon icon-close"></span>' + t("something_went_wrong_try_again", "Something went wrong. Please try again.") + '</div></li></ul>';
                    $messages.html(html).addClass('has-error');
                });
        });
    }

    // Init once on DOM ready
    initAuthFormsValidation();
    initAjaxLogin();
    initAjaxRegister();

    // Re-init when Magnific Popup opens login popup
    $(document).on('mfpOpen', function () {
        var mfp = $.magnificPopup.instance;

        if (mfp && mfp.content && mfp.content.attr('id') === 'login-form-popup') {
            // Reset registration form view if it was in success state
            var $container = $('#custom-registration-form');
            if ($container.length) {
                $container.find('.registration-success-message').remove();
                $container.find('form.register').show();
            }

            initAuthFormsValidation();
            initAjaxLogin();
            initAjaxRegister();
        }
    });
});